<template>
<div class="papsi-wrapper">
    <div class="papsi-wrapper flex justify-between">
        <div>
            <h1 class="text-2xl font-semibold text-[#24723b]">Leave Requests</h1>
            <p class="text-xs text-[#747474] mt-2">Home / Leave Requests</p>
        </div>
        <div>
            <button  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1' , notactive: activeBtn === 'Button2'}">Requests Status</button>
            <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"  @click="activeBtn = 'Button2'" v-bind:class="{active: activeBtn === 'Button2', notactive: activeBtn === 'Button1'}"  >Noted Requests</button>
        </div>
    </div>
</div>
<div class="mt-11">
    <div v-if="activeBtn === 'Button1'" class="grid grid-cols-11 w-full gap-3 mb-5 ">
        <input type="text" @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
        <select @change="leaveFilter" class="w-[250px] border-[#b7b8b7] border  rounded-md   outline-none p-2 px-5  text-[#535353]  text-xs font-semibold" v-model="filtered">
            <option value="R">FOR RECOMMENDATION</option>
            <option value="P">FOR APPROVAL</option>
            <option value="A">APPROVED</option>
            <option value="D">DISAPPROVED</option>
            <option value="ALL">ALL</option>
        </select> 
    </div>
    <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
        
        <TableControl v-if="activeBtn === 'Button1'"  :Action="true" :header="header"  :column="column" :info="DisplayLeave" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewTable" />

        <TableControl v-if="activeBtn === 'Button2'" :Action="true" :header="header1" :column="columnNoted" :info="NotedLeaveDisplay" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewTable"/>                
    </div>
</div>
<div class="" v-if="ViewLeaveModal">
    <LeaveModal @CloseLeave="ViewLeaveModal = false" @cancel="ViewLeaveModal = false" :activeBtn='activeBtn' :Data="ViewDataLeave" @Approve="RecommendLeave" :Approval="true" @NoteLeave="NoteLeave"/>
</div>
</template>
<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import TableControl from '.././TableControl/TableControl.vue'
import Services from '../../../services/admin' 
import LeaveModal from '.././modal/LeaveFormModal.vue'

export default defineComponent(
{
    components:{
        TableControl,
        LeaveModal
    },
    data(){ 
        return{
            isTyping:false,
            search:'',
            filtered: 'ALL',
            ViewLeaveModal:false,
            ViewDataLeave:'',
            DisplayLeave:'',
            activeBtn: "Button1",
            test:false,
            Data:'',
            NotedLeaveDisplay:'',
            header:[
                {title: 'Reference No.'},
                {title: 'Employee No.'},
                {title: 'Employee Name'},
                {title: 'Duration'},
                {title: 'Status'},
                {title: 'Action'},
            ],
            header1:[
                {title: 'Reference No.'},
                {title: 'Employee No.'},
                {title: 'Employee Name'},
                {title: 'Noted By'},
                {title: 'Action'},
            ],
            column:[
                'leave_key',
                'employee_key',
                'employee_name',
                'duration',
                'con_status'
            ],
            columnNoted:[
                'leave_key',
                'employee_key',
                'employee_name',
                'noted_by'
            ],   
        }
     },
    mounted(){
       this.getAllLeaveRequest()
       this.NotedLeave()
    },
    watch: {
                search: _.debounce(function() {
                this.isTyping = false;
                }, 700),
                isTyping: function(value) {
                if (!value) {
                    this.searchLeave()
                }
                }
    },
    methods:{
        async getAllLeaveRequest(){
            this.$emit("showLoader")
            const success     = await Services.getAllRequestLeave(this.search);
            this.AllLeave = success.data
            this.DisplayLeave = success.data
            this.$emit("hideLoader")
        },
        async searchLeave(){
            const success     = await Services.getAllRequestLeave(this.search);
            this.AllLeave = success.data
            this.DisplayLeave = success.data
            this.leaveFilter()
        },
        leaveFilter(){
            if(this.filtered == 'ALL' ){
                this.DisplayLeave = this.AllLeave
                return
            }
            this.DisplayLeave = this.AllLeave.filter(status=>status.con_status == this.filtered)
        },
        async NotedLeave(){
            this.$emit("showLoader")
            const success     = await Services.getAllNotedRequestLeave();
            this.NotedLeaveDisplay = success.data
            this.$emit("hideLoader")
        },
        ViewTable(row){
            this.ViewDataLeave = row
            this.ViewLeaveModal = true
        },
        async NoteLeave(leave_key){
            this.$emit("showLoader")
            let state = this.$store.state
            await Services.notedByLeave(state.employee_key,leave_key);
            this.getAllLeaveRequest()
            this.ViewLeaveModal = false
            this.NotedLeave()
            this.$emit("hideLoader")
        } 
    }
})
</script>

<style scoped>
.active {
    color: #ffffff;
    background-color: #24723b;
  }
  .notactive {
    background-color: #CCAF12;
    color: #ececec;
  }
</style>
